import { useHookstate } from "@hookstate/core";
import { Release } from "../../../../types";
import { readerDataStore } from "../../../../hookstate/readerDataStore";

export function useComicReleasesData() {
  const comicReleasesData = useHookstate(readerDataStore.comicReleasesData).get(
    {
      noproxy: true,
    },
  );

  const setComicReleasesData = (data: Release[]) => {
    readerDataStore.comicReleasesData.set(data);
  };

  return { comicReleasesData, setComicReleasesData };
}
